// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4254 ? "56c12eb5" : chunkId) + "." + {"3071":"b23614b35b6fa324","3097":"edb21912a5525e55","4254":"cfaf0f642ce9413b","8288":"c9249e76cc9c6b37"}[chunkId] + ".js";
};